module.exports = __webpack_public_path__ + "static/media/Backdrop_Casino.6085c729.png";